import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Button from '@twicapp/ui/components/Button';
import Background from 'assets/images/hero-login.svg';
import { ReactComponent as Logo } from 'assets/images/logo-dark.svg';
import { SCREEN_WIDTHS } from '@twicapp/ui/constants/breakpoints';
import {
  BUTTON_VARIANTS,
  BUTTON_SIZES,
} from '@twicapp/ui/constants/properties';

import { RootRoutes } from 'utils/routeGenerator';

const Container = styled.main`
  background-image: url(${() => Background});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
`;

const Navbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (min-width: ${SCREEN_WIDTHS.MOBILE_LANDSCAPE}) {
    padding: 20px 52px;
  }
`;

const StyledLogo = styled(Logo)`
  height: 33px;
`;

const ExternalLink = styled.a``;
const AdminLoginButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.SECONDARY,
  size: BUTTON_SIZES.SMALL,
})``;

const LoginLayout = ({ children }: { children: React.ReactNode }) => (
  <Container>
    <Navbar>
      <Link to={RootRoutes.login()}>
        <StyledLogo />
      </Link>
      <ExternalLink
        href={
          process.env.REACT_APP_ADMIN_LOGIN_URL ||
          'https://client-admin.twic.ai/signin'
        }
      >
        <AdminLoginButton>Employer Sign In</AdminLoginButton>
      </ExternalLink>
    </Navbar>
    {children}
  </Container>
);

export default LoginLayout;
